export enum HybrisResponseFieldsType {
    Full = 'FULL',
    Default = 'DEFAULT',
    Basic = 'BASIC',
}
